module.exports = __webpack_public_path__ + "static/media/ppsc-banner.44c46f78.svg";